<template lang="pug">
v-col.pa-0(v-if='Servicios')
    //- PARA PC
    v-container(fluid).d-none.d-md-block.pa-0.medidaPC
      .header.d-none.d-md-flex
        .titulo.mt-8
          v-col(cols=12 md=6).align-center.text-center
            v-row.justify-center.align-center
              h1.align-center.text-center( style='line-height : 20px; font-size: 45px; color:var(--primary)' ) {{Servicios.titulo}}

              h2.font-weight-bold(  style='font-size: 35px; line-height : px; color:var(--secondary)' ) {{Servicios.Subtitle}}
            
              div.d-flex.flex-column.align-center.mt-1 
                .lineamorada( style='width:100px')
        .contenido.mt-3
          v-col(cols=12 md=12)
            v-row(align='center' justify='center')
              v-btn.mr-5( @click='atras()' outlined icon) 
                v-icon mdi-arrow-left
              v-card.pa-0.ml-1.mr-1(ref='cartita' flat v-for='{imagen, subtitulo, imagenActive},i of galeria' :key='i')
                v-col(align='center' justify='center')             
                  v-img( :src='i == 1 ? imagenActive : imagen ' height='100%' contain width='360px')
                  p.mt-5(size='40px' style=' color:var(--secondary)').align-center {{subtitulo}}  
              v-btn.ml-5( @click='siguiente()' icon outlined)
                v-icon mdi-arrow-right
        .footer
          v-row.justify-center.align-center.mt-7
            v-btn(  target='_blank' :href='Servicios.vinculobotonBE'  style=' color:var(--secondary)'  outlined rounded x-large).elevation-0
              v-row
                v-col
                  span PORTAFOLIO 
                v-col.behance
                  h3 | Bē
    //-PARA MOVIL
    v-container.pa-0.d-md-none.vhMovil
      v-row.align-center.text-center
        v-col(cols=12 ).mt-5
          v-row.justify-center.align-center
            h1.align-center.text-center( style=' font-size: 33px; color:var(--primary)' ) {{Servicios.titulo}}
              h2.font-weight-bold(  style=' line-height : 15px; font-size: 25px; color:var(--secondary)' ) {{Servicios.Subtitle}}
          div.d-flex.flex-column.align-center.mt-4 
            .lineamorada( style='width:100px')
                    
      v-container.d-md-none.vhMovil
        v-row.justify-center.align-center
          v-col()
            //-carrusel
            v-carousel(   v-model='step' :hide-delimiter-background='true' :show-arrows="false"  )
              v-carousel-item( style='position: relative' v-for='{imagen, subtitulo}, i of Servicios.contenido' :key='i')
                v-col(align='center' justify='center')
                  v-img(:src='imagen' height='100% ' contain)
                  //-subtitulo
                  p.font-weight-bold.mt-7(style=' font-size: 20px; color:var(--secondary)').align-center {{subtitulo}}  
              //-botones
        v-container.d-md-none.espacio
          v-col(align='center' justify='center')
            v-row(align='center' justify='center').my-4
              v-btn.mr-5( style=' color:var(--secondary)' @click='step--' outlined icon) 
                v-icon mdi-arrow-left 
              v-btn.ml-5( style=' color:var(--secondary)' @click='step++' icon outlined)
                v-icon mdi-arrow-right
          
            v-row(align='center' justify='center').mt-7
              v-btn( target='_blank' :href='Servicios.vinculobotonBE' style=' color:var(--secondary)' large outlined rounded )
                span PORTAFOLIO 
                .behance.ml-1
                h3 | Bē
        

</template>
<style lang="sass" scoped>
.espacio

  position: absolute
  bottom: 200px
  left: 0
  right: 0
  margin: auto
.behance
  position: relative
  right: 10%
.vhMovil
    height: 840px
    position: relative
.lineamorada
    height: 4px
    background-color: #270640 !important  
.colorletras
  background-color: var(--secondary)

.medidaPC
  height: 95vh
.header 
  height: 100vh
  background-color: #ffffff
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  background-size: cover
  .titulo 
    height: 20vh
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    background-size: cover
    .lineamorada 
      height: 4px
      background-color: var(--secondary)
  .contenido 
    height: 60vh
  .footer
    height: 20vh

.v-card
  position: relative
  background-color: transparent,
  height: 30vh
  width: 30vh
  &.selected
    animation-duration: 1s
    animation-name: presentar
    animation-fill-mode: forwards
    >p
    font-size: 25px
    font-weight: 900
  &.fadeLeft
    animation-duration: 1s
    animation-name: fadeLeft
    animation-fill-mode: forwards
@keyframes fadeLeft
  0%
    opacity: 1
    transform: translateX(0px)
  100%
    opacity: 0
    transform: translateX(-10px)
@keyframes presentar
  0%
    opacity: 0
    //transform: translateX(0px)
  100%
    opacity: 1
    //transform: translateX(0px)
  from 
    height: 30vh
    width: 30vh
  to 
    height: 40vh
    width: 40vh
    

</style>
<script>
export default {
    data () {
      return {
        seleccionado: 0,
        step: 0,
      }
    },
    computed: {
      galeria(){
        const orden = []
        const objeto = []
        const anterior = this.seleccionado == 0 ? this.Servicios.contenido.length -1 : this.seleccionado-1
        orden.push(anterior)
        orden.push(this.seleccionado)
        const siguiente = this.seleccionado == this.Servicios.contenido.length -1 ? 0 : this.seleccionado +1
        orden.push(siguiente)
        orden.map(indice => { 
          
          const item = this.Servicios.contenido.map((item, index) => { 
            if(index== indice ) return item 
          }).filter(item => item)
          objeto.push(item)
        })
        
        
        return objeto.flat()
      }
    },
   
    methods: {
      agregarTransicion(){
        
        this.$refs.cartita.map(item=>{item.$el.classList.remove("selected") })
        setTimeout(()=>{this.$refs.cartita[1].$el.classList.add("selected") },100)
      },
      fadeLeft(){
        this.$refs.cartita.map(item=>{item.$el.classList.remove("fadeLeft") })
        setTimeout(()=>{this.$refs.cartita[1].$el.classList.add("fadeLeft") },100)
      },
      siguiente(){
        if(this.seleccionado < this.Servicios.contenido.length -1 ) this.seleccionado += 1 
        else this.seleccionado = 0
        this.agregarTransicion()
      },
      atras(){
        if(this.seleccionado != 0 ) this.seleccionado -= 1 
        else this.seleccionado = this.Servicios.contenido.length -1 
        this.agregarTransicion()

      },
      
    },
    created(){
      setTimeout(() => {
          this.agregarTransicion()
      }, 3000)
    }
}
</script>
